/* tslint:disable */
/* eslint-disable */
/**
 * Commerce API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Price } from './Price';
import {
    PriceFromJSON,
    PriceFromJSONTyped,
    PriceToJSON,
} from './Price';
import type { ProductAddonCard } from './ProductAddonCard';
import {
    ProductAddonCardFromJSON,
    ProductAddonCardFromJSONTyped,
    ProductAddonCardToJSON,
} from './ProductAddonCard';
import type { ProductSplashDiscountModel } from './ProductSplashDiscountModel';
import {
    ProductSplashDiscountModelFromJSON,
    ProductSplashDiscountModelFromJSONTyped,
    ProductSplashDiscountModelToJSON,
} from './ProductSplashDiscountModel';

/**
 * 
 * @export
 * @interface ProductCardModel
 */
export interface ProductCardModel {
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductCardModel
     */
    images?: Array<string>;
    /**
     * 
     * @type {Price}
     * @memberof ProductCardModel
     */
    price?: Price;
    /**
     * 
     * @type {ProductSplashDiscountModel}
     * @memberof ProductCardModel
     */
    splash?: ProductSplashDiscountModel;
    /**
     * 
     * @type {string}
     * @memberof ProductCardModel
     */
    googleProductCategory?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductCardModel
     */
    affiliation?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductCardModel
     */
    brand?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductCardModel
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ProductCardModel
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductCardModel
     */
    url?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductCardModel
     */
    designer?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductCardModel
     */
    relatedProductIds?: Array<string>;
    /**
     * 
     * @type {Array<ProductAddonCard>}
     * @memberof ProductCardModel
     */
    addons?: Array<ProductAddonCard>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductCardModel
     */
    selectedOptions?: Array<string>;
}

/**
 * Check if a given object implements the ProductCardModel interface.
 */
export function instanceOfProductCardModel(value: object): boolean {
    if (!('id' in value)) return false;
    return true;
}

export function ProductCardModelFromJSON(json: any): ProductCardModel {
    return ProductCardModelFromJSONTyped(json, false);
}

export function ProductCardModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductCardModel {
    if (json == null) {
        return json;
    }
    return {
        
        'images': json['images'] == null ? undefined : json['images'],
        'price': json['price'] == null ? undefined : PriceFromJSON(json['price']),
        'splash': json['splash'] == null ? undefined : ProductSplashDiscountModelFromJSON(json['splash']),
        'googleProductCategory': json['googleProductCategory'] == null ? undefined : json['googleProductCategory'],
        'affiliation': json['affiliation'] == null ? undefined : json['affiliation'],
        'brand': json['brand'] == null ? undefined : json['brand'],
        'id': json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'url': json['url'] == null ? undefined : json['url'],
        'designer': json['designer'] == null ? undefined : json['designer'],
        'relatedProductIds': json['relatedProductIds'] == null ? undefined : json['relatedProductIds'],
        'addons': json['addons'] == null ? undefined : ((json['addons'] as Array<any>).map(ProductAddonCardFromJSON)),
        'selectedOptions': json['selectedOptions'] == null ? undefined : json['selectedOptions'],
    };
}

export function ProductCardModelToJSON(value?: ProductCardModel | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'images': value['images'],
        'price': PriceToJSON(value['price']),
        'splash': ProductSplashDiscountModelToJSON(value['splash']),
        'googleProductCategory': value['googleProductCategory'],
        'affiliation': value['affiliation'],
        'brand': value['brand'],
        'id': value['id'],
        'name': value['name'],
        'url': value['url'],
        'designer': value['designer'],
        'relatedProductIds': value['relatedProductIds'],
        'addons': value['addons'] == null ? undefined : ((value['addons'] as Array<any>).map(ProductAddonCardToJSON)),
        'selectedOptions': value['selectedOptions'],
    };
}

